
















import { Component, Prop, Vue } from 'vue-property-decorator';
import { AppHeading, AppText } from '@/uikit';

@Component({
  components: {
    AppHeading,
    AppText,
  },
})
export default class InvitedPerson extends Vue {
  @Prop({ type: String, default: '' })
  readonly fio!: string;

  @Prop({ type: String, default: '' })
  readonly email!: string;

  @Prop({ type: String, default: '' })
  readonly state!: string;
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/profile/blocks/children/sidebar/components/invitedperson/InvitedPerson.vue